import { render, staticRenderFns } from "./wangdian.vue?vue&type=template&id=092bb72a&"
import script from "./wangdian.vue?vue&type=script&lang=js&"
export * from "./wangdian.vue?vue&type=script&lang=js&"
import style0 from "./wangdian.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports